// document.querySelectorAll('#s-viewport-iframe iframe')[1]
// document.querySelectorAll('#s-viewport-iframe iframe')[1].getAttribute('tag-id')

const IFRAME_CONTAINER_ID = 's-viewport-iframe'

function getIframeNodeList() {
  return document.querySelectorAll(`#${IFRAME_CONTAINER_ID} iframe`)
}

export function getIframeTagIdByWindow(win) {
  const iframeNodeList = getIframeNodeList()
  for (let i = 0; i < iframeNodeList.length; i++) {
    const iframeNode = iframeNodeList[i]
    if (iframeNode && iframeNode.contentWindow === win) {
      return iframeNode.getAttribute('tag-id')
    }
  }

  return undefined
}

export function getIframeContentWindowByTagId(tagId) {
  const iframeDom = document.querySelector(`iframe[tag-id="${tagId}"]`)
  return iframeDom ? iframeDom.contentWindow : null
}
